import styles from './style.module.css';
import NavLink from '@components/Common/NavLink';
import {useRouter} from 'next/router';
import {CMSBreadcrumb} from '@interfaces/content-container';
import {LocaleEnum} from '@enums/locale';
import {ComponentWithChildrenProps} from '@interfaces/component';
import {locale} from 'moment';

interface BreadcrumbProps extends ComponentWithChildrenProps {
  justifyStart?: boolean;
  classNames?: string;
  baseUrl?: string;
  borderBottom?: boolean;
  namePrefix?: string;
  list?: CMSBreadcrumb[];
}
export default function Breadcrumb(props: BreadcrumbProps) {
  const {
    list,
    justifyStart,
    classNames,
    baseUrl,
    borderBottom,
    children,
    namePrefix = 'product_group_name',
  } = props;
  const router = useRouter();
  const links = list?.map((item, key) => {
    const linkName = item[`${namePrefix}`] as string;
    const slug = item['seo_friendly_url'];
    const URL = baseUrl ? `${baseUrl.replace(/\/+$/, '')}/${slug}` : slug;
    return (
      <NavLink
        key={key}
        href={`${key + 1 === list.length ? router.asPath : URL}`}
        locale={router.locale}
      >
        {linkName}
      </NavLink>
    );
  });

  return (
    <div className={`${styles.breadcrumb} ${classNames}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <ul
              className={`${borderBottom && styles.borderBottom} ${
                styles.breadcrumbNav
              } ${justifyStart && styles.justifyStart}`}
            >
              {children
                ? children
                : links?.map(link => {
                    return link;
                  })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
